import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CustomScroll from 'react-custom-scroll'
import Gallery from '../containers/Gallery.js'
import LazyLoader from '../../../modules/LazyLoader.js'
import {
  openLinksInNewWindow
} from '../../../modules/Helpers.js'

export default class Content extends Component {
  componentDidUpdate () {
    openLinksInNewWindow()
    const lazy = new LazyLoader({
      container: document.querySelector('.content-body'),
      elements_selector: '.lazy',
      callback_load: function (el) {
        el.parentNode.style.background = 'none'
      }
    })
  }
  renderLinks (page) {
    return (
      <div className='content-body'>
        { page.links && page.links.map((item, i) => {
          return (
            <div key={i} className='content-link'>
              <figure className='content-link-image'>
                {item.image &&
                  <img className='lazy'
                    src='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
                    data-src={item.image}
                    width={item.image_w}
                    height={item.image_h}
                  />
                }
              </figure>
              <div className='content-link-text'>
                {item.title && !item.link &&
                  <span >{item.title}</span>
                }
                {item.link && item.link &&
                  <a href={item.link}>{item.title}</a>
                }
              </div>
            </div>
          )
        })
        }
      </div>
    )
  }
  renderPage (page) {
    return (
      <div className='content-body'>
        { page.body &&
          <div className='text-container' dangerouslySetInnerHTML={{ __html: page.body }} ></div>
        }
        { page.media &&
          <Gallery media={page.media} />
        }
      </div>
    )
  }
  renderCollection (collection) {
    return (
      collection.map((item, i) =>
        <div className='collection-body' key={i}>
          <div className="collection-title">
            <strong>
              {item.title}
            </strong>
          </div>
          {this.renderPage(item)}
        </div>
      )
    )
  }
  render () {
    const {
      className,
      content
    } = this.props

    return (
      <CustomScroll heightRelativeToParent="100%">
        <div className={className}>
          {
            content &&
            content.collections &&
            !content.links &&
            <div className='content-body'>
              {this.renderCollection(content.collections)}
            </div>
          }
          {
            content &&
            !content.collections &&
            !content.links &&
            this.renderPage(content)
          }
          {
            content &&
            content.links &&
            this.renderLinks(content)
          }
        </div>
      </CustomScroll>
    )
  }
}

Content.defaultProps = {
  className: 'page-content',
  content: ''
}

Content.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
}
